// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-comp {
  max-width: 300px;
}

.btn-link {
  color: white;
}

.strike {
  display: block;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
}

.strike > span {
  position: relative;
  display: inline-block;
}

.strike > span:before,
.strike > span:after {
  content: "";
  position: absolute;
  top: 50%;
  width: 9999px;
  height: 1px;
  background: rgba(255, 213, 79, 0.8);
}

.strike > span:before {
  right: 100%;
  margin-right: 15px;
}

.strike > span:after {
  left: 100%;
  margin-left: 15px;
}

.g-signin {
  background: url('g_signin_normal.png');
  background-size: contain !important;
}

.g-signin:hover {
  cursor: pointer;
  background: url('g_signin_pressed.png')
}

.g-signin:focus {
  background: url('g_signin_focus.png')
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImxvZ2luLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxnQkFBZ0I7QUFDbEI7O0FBRUE7RUFDRSxZQUFZO0FBQ2Q7O0FBRUE7RUFDRSxjQUFjO0VBQ2Qsa0JBQWtCO0VBQ2xCLGdCQUFnQjtFQUNoQixtQkFBbUI7QUFDckI7O0FBRUE7RUFDRSxrQkFBa0I7RUFDbEIscUJBQXFCO0FBQ3ZCOztBQUVBOztFQUVFLFdBQVc7RUFDWCxrQkFBa0I7RUFDbEIsUUFBUTtFQUNSLGFBQWE7RUFDYixXQUFXO0VBQ1gsbUNBQW1DO0FBQ3JDOztBQUVBO0VBQ0UsV0FBVztFQUNYLGtCQUFrQjtBQUNwQjs7QUFFQTtFQUNFLFVBQVU7RUFDVixpQkFBaUI7QUFDbkI7O0FBRUE7RUFDRSxzQ0FBNkM7RUFDN0MsbUNBQW1DO0FBQ3JDOztBQUVBO0VBQ0UsZUFBZTtFQUNmO0FBQ0Y7O0FBRUE7RUFDRTtBQUNGIiwiZmlsZSI6ImxvZ2luLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIubG9naW4tY29tcCB7XG4gIG1heC13aWR0aDogMzAwcHg7XG59XG5cbi5idG4tbGluayB7XG4gIGNvbG9yOiB3aGl0ZTtcbn1cblxuLnN0cmlrZSB7XG4gIGRpc3BsYXk6IGJsb2NrO1xuICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gIG92ZXJmbG93OiBoaWRkZW47XG4gIHdoaXRlLXNwYWNlOiBub3dyYXA7XG59XG5cbi5zdHJpa2UgPiBzcGFuIHtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuICBkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG59XG5cbi5zdHJpa2UgPiBzcGFuOmJlZm9yZSxcbi5zdHJpa2UgPiBzcGFuOmFmdGVyIHtcbiAgY29udGVudDogXCJcIjtcbiAgcG9zaXRpb246IGFic29sdXRlO1xuICB0b3A6IDUwJTtcbiAgd2lkdGg6IDk5OTlweDtcbiAgaGVpZ2h0OiAxcHg7XG4gIGJhY2tncm91bmQ6IHJnYmEoMjU1LCAyMTMsIDc5LCAwLjgpO1xufVxuXG4uc3RyaWtlID4gc3BhbjpiZWZvcmUge1xuICByaWdodDogMTAwJTtcbiAgbWFyZ2luLXJpZ2h0OiAxNXB4O1xufVxuXG4uc3RyaWtlID4gc3BhbjphZnRlciB7XG4gIGxlZnQ6IDEwMCU7XG4gIG1hcmdpbi1sZWZ0OiAxNXB4O1xufVxuXG4uZy1zaWduaW4ge1xuICBiYWNrZ3JvdW5kOiB1cmwoXCJhc3NldHMvZ19zaWduaW5fbm9ybWFsLnBuZ1wiKTtcbiAgYmFja2dyb3VuZC1zaXplOiBjb250YWluICFpbXBvcnRhbnQ7XG59XG5cbi5nLXNpZ25pbjpob3ZlciB7XG4gIGN1cnNvcjogcG9pbnRlcjtcbiAgYmFja2dyb3VuZDogdXJsKCdhc3NldHMvZ19zaWduaW5fcHJlc3NlZC5wbmcnKVxufVxuXG4uZy1zaWduaW46Zm9jdXMge1xuICBiYWNrZ3JvdW5kOiB1cmwoJ2Fzc2V0cy9nX3NpZ25pbl9mb2N1cy5wbmcnKVxufVxuIl19 */`, "",{"version":3,"sources":["webpack://./src/app/login/login.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,sCAA6C;EAC7C,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA,gyDAAgyD","sourcesContent":[".login-comp {\n  max-width: 300px;\n}\n\n.btn-link {\n  color: white;\n}\n\n.strike {\n  display: block;\n  text-align: center;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.strike > span {\n  position: relative;\n  display: inline-block;\n}\n\n.strike > span:before,\n.strike > span:after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  width: 9999px;\n  height: 1px;\n  background: rgba(255, 213, 79, 0.8);\n}\n\n.strike > span:before {\n  right: 100%;\n  margin-right: 15px;\n}\n\n.strike > span:after {\n  left: 100%;\n  margin-left: 15px;\n}\n\n.g-signin {\n  background: url(\"assets/g_signin_normal.png\");\n  background-size: contain !important;\n}\n\n.g-signin:hover {\n  cursor: pointer;\n  background: url('assets/g_signin_pressed.png')\n}\n\n.g-signin:focus {\n  background: url('assets/g_signin_focus.png')\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
